import { useEffect, useState } from 'react';
import { ResurrectionBannerNonEmptyState } from '../ResurrectionBannerNonEmptyState';
import I18n from 'I18n';
import { checkWithinSevenDays } from '../../utils/renewalDate';
import { useHasLocalStorageDismissal } from '../../hooks/useHasLocalStorageDismissal';
import { setExperimentCohortInTracker, trackDismissResurrectionBanner, trackTurnOnAutoRenew, trackAutoRenewSuccess, trackAutoRenewError } from '../../utils/tracking';
import { getUserInfo } from '../../utils/scopes';
import { TurnAutoRenewalOnButton } from 'account-and-billing-components';
import { jsx as _jsx } from "react/jsx-runtime";
export const RES_0010_TREATMENT_KEY = 'res-0010';
export const RES_0010_VARIANT = 'variation';
const setDismissalTimeLimit = (subscriptionRenewalDate, setDismissInLocalStorage) => {
  const dismissalTimeLimit = checkWithinSevenDays(new Date(subscriptionRenewalDate)) ? '7days' : '30days';
  setDismissInLocalStorage(dismissalTimeLimit);
};
export const MaybeIsVariant = ({
  featureLimitName,
  subscriptionRenewalDate,
  subscriptionId,
  logExposure,
  treatments,
  lostFeature,
  productApiName
}) => {
  const user = getUserInfo();
  const [autoRenewSuccessful, setAutoRenewSuccessful] = useState(false);
  const [isVariant, setIsVariant] = useState(false);
  const {
    dismissInLocalStorage,
    setDismissInLocalStorage
  } = useHasLocalStorageDismissal(featureLimitName, subscriptionRenewalDate);

  // Log effect
  useEffect(() => {
    logExposure(RES_0010_TREATMENT_KEY);
  }, [logExposure]);
  useEffect(() => {
    const resolveTreatment = async () => {
      const resolvedTreatments = await treatments;
      const treatment = resolvedTreatments[RES_0010_TREATMENT_KEY].parameters.group;
      setIsVariant(treatment === RES_0010_VARIANT);
      setExperimentCohortInTracker(treatment);
    };
    void resolveTreatment();
  }, [treatments]);
  if (!isVariant) {
    return null;
  }
  if (dismissInLocalStorage === '7days' || dismissInLocalStorage === '30days') {
    return null;
  }
  return /*#__PURE__*/_jsx(ResurrectionBannerNonEmptyState, {
    featureLimitName: featureLimitName,
    endDate: new Date(subscriptionRenewalDate),
    featureLoss: lostFeature.usage - lostFeature.lowerLimit,
    featureLimit: lostFeature.usage,
    subscriptionId: subscriptionId,
    productApiName: productApiName,
    onClose: () => {
      setDismissalTimeLimit(subscriptionRenewalDate, setDismissInLocalStorage);
      trackDismissResurrectionBanner(featureLimitName);
    },
    buttonSlot: /*#__PURE__*/_jsx(TurnAutoRenewalOnButton, {
      userInfo: user,
      use: "tertiary",
      subscriptionId: subscriptionId || 0,
      errorButtonText: I18n.text('resurrectionBanner.nonEmptyState.tryAgain'),
      onButtonClick: () => {
        trackTurnOnAutoRenew(featureLimitName);
      },
      onSuccess: () => {
        setAutoRenewSuccessful(true);
        trackAutoRenewSuccess(featureLimitName);
      },
      onError: () => {
        trackAutoRenewError(featureLimitName);
      }
    }),
    autoRenewSuccessful: autoRenewSuccessful
  });
};